import { cn } from '~/styles/extended-theme';

interface Props {
  className?: string;
}

export function FacebookLogo({ className }: Props) {
  return (
    <img className={cn('h-6 w-6', className)} src="/img/Facebook_Logo_Primary.png" alt="Facebook" />
  );
}
